import { useContext } from 'react';

import { QuestionChangeModalContext } from './question-change-modal-provider';

function useQuestionChangeModal() {
  const context = useContext(QuestionChangeModalContext);

  if (!context) {
    throw new Error('useQuestionChangeModal must be used within a QQuestionChangeModalProvider');
  }

  return context;
}

export { useQuestionChangeModal };
